<template>
    <div>
        <card-header title="Edit Certification Application" icon="fa-pencil" />

        <card-body v-if="app.id">
            <course-application-form :app="app"/>

            <card-list>
                <subheader-list-item title="Certification Approval" icon="fa-memo-circle-check" />
            </card-list>

            <data-row title="Requires Approval">
                <i class="fas fa-check mr-2 has-text-success" v-if="app.applications.is_require_approval"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i>
            </data-row>
            <data-row title="Approved" v-if="app.applications.is_require_approval">
                <i class="fas fa-check mr-2 has-text-success" v-if="app.is_approved"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i>
            </data-row>
            <data-row title="Approval Date" v-if="app.applications.is_require_approval">
                <span v-if="app.approved_at">{{ app.approved_at | moment('MMMM Do, YYYY') }}</span><span v-else>N/A</span>
            </data-row>

            <card-list v-if="app.applications.is_require_approval">
                <subheader-list-item title="Approval History" icon="fa-clock-rotate-left" />

                <card-list-item v-for="approval in app.conf_application_approvals">
                    <template v-slot:icon><i class="far fa-user fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="tile-title">{{ approval.portal_users.first_name }} {{ approval.portal_users.last_name }}</div>
                        <div class="meta">Approved on {{ approval.created_at | moment('MMMM Do') }}</div>
                    </template>
                </card-list-item>
            </card-list>

        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <!--                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteType"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Type?</span></b-button>-->
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                    ><i class="fas fa-check mr-2"></i>Save Application
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from '@/http_client';
    import CardList from "../../../TIER/components/CardList.vue";
    import SubheaderListItem from "../../../TIER/components/SubheaderListItem.vue";
    import DataRow from "../../../TIER/components/DataRow.vue";
    import CardListItem from "../../../TIER/components/CardListItem.vue";
    import CourseApplicationForm from "./CourseApplicationForm.vue";

    export default {
        components: {CourseApplicationForm, CardListItem, DataRow, SubheaderListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                app: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadApp: function () {
                this.$emit('loading', true);
                http.get('courses/' + this.props.courseId + '/applications/' + this.props.appId, {force: true}).then(response => {
                    this.app = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function () {
                http.put('courses/' + this.props.courseId + '/applications/' + this.props.appId, {
                    id: this.app.id,
                    min_minutes_required: this.app.min_minutes_required,
                    max_units: this.app.max_units,
                    flat_price: this.app.flat_price,
                    per_unit_price: this.app.per_unit_price,
                    is_active: this.app.is_active,
                    is_enabled: this.app.is_enabled,
                    is_required_at_end: this.app.is_required_at_end,
                    syllabus: this.app.syllabus,
                    goals: this.app.goals,
                    objectives: this.app.objectives,
                    outcomes: this.app.outcomes,
                    standards: this.app.standards,
                    instructor: this.app.instructor,
                    resume: this.app.resume,
                    num_participants: this.app.num_participants
                }, {force: true}).then(response => {
                    this.$reloadCard('course', {courseId: this.props.courseId});
                    this.$reloadCard('course-app', {courseId: this.props.courseId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the application.');
                    this.$emit('loading', false);
                });
            },
            // deleteType() {
            //     if (this.confirmDelete) {
            //         this.$emit('loading', true);
            //
            //         http.delete('courses/' + this.props.courseId + '/types/' + this.type.id).then(response => {
            //             this.$reloadCard('conf-reg-types', {courseId: this.props.courseId});
            //             this.$saveAlert(false);
            //             this.$closeCard(this.card);
            //         }).catch(err => {
            //
            //         });
            //     } else {
            //         this.confirmDelete = true;
            //         setTimeout(() => {
            //             this.confirmDelete = false;
            //         }, 3000);
            //     }
            // }
        },
        watch: {
            'props.appId': function () {
                this.dirty = null;
                this.loadApp();
            },
            'type': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this application? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadApp();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
